import React from "react";
import { SiReact, SiNextdotjs, SiNodedotjs, SiMongodb, SiTailwindcss, SiAmazonwebservices, SiGit, SiDocker } from "react-icons/si";
import { Container } from "../home/ui";

// Box background (laptop illustration bottom-left, rounded corners and dots are part of the image).
// File: public/img/tech-stack-bg.jpg. Used on desktop only (via the --tech-bg CSS variable);
// smaller screens get the soft gradient.
const sectionBg = "/img/tech-stack-bg.jpg";

const tech = [
  { icon: SiReact, label: "React", cls: "text-[#22B8E8]", ring: "bg-[#E7F7FD]" },
  { icon: SiNextdotjs, label: "Next.js", cls: "text-black", ring: "bg-[#F2F3F6]" },
  { icon: SiNodedotjs, label: "Node.js", cls: "text-[#539E43]", ring: "bg-[#EAF6E7]" },
  { icon: SiMongodb, label: "MongoDB", cls: "text-[#3FA037]", ring: "bg-[#E9F6EC]" },
  { icon: SiTailwindcss, label: "Tailwind CSS", cls: "text-[#38BDF8]", ring: "bg-[#E7F7FD]" },
  { icon: SiAmazonwebservices, label: "AWS", cls: "text-[#232F3E]", ring: "bg-[#FFF5E8]" },
  { icon: SiGit, label: "Git", cls: "text-[#F05032]", ring: "bg-[#FDEDEA]" },
  { icon: SiDocker, label: "Docker", cls: "text-[#1D91E6]", ring: "bg-[#E7F1FD]" },
];

const TechStack = () => (
  <section className="bg-white py-[24px] lg:py-[40px]">
    <Container className="max-w-[1320px]">
      {/* On desktop the box keeps the image's exact ratio (2548x1172) so the artwork is never cropped or stretched;
          the image already contains the rounded corners, the laptop and the dotted decoration. */}
      <div
        className="relative overflow-hidden rounded-[22px] bg-gradient-to-br from-[#F2F5FF] via-[#F5F3FF] to-[#F1F4FF] px-[22px] py-[30px] sm:px-[36px] lg:flex lg:aspect-[2548/1172] lg:items-center lg:rounded-[2.2%/4.8%] lg:bg-[image:var(--tech-bg)] lg:bg-[length:100%_100%] lg:bg-no-repeat lg:px-[4.2%] lg:py-[3%]"
        style={{ "--tech-bg": `url(${sectionBg})` }}
      >
        <div className="relative grid w-full gap-[28px] lg:h-full lg:grid-cols-[44%_1fr] lg:gap-[3%]">
          {/* Text sits in the top-left, above the laptop in the artwork */}
          <div className="lg:pt-[2.5%]">
            <p className="flex items-center gap-[12px] text-[12px] font-medium uppercase tracking-[0.2em] text-[#1E4DFF] xl:text-[clamp(11px,0.85vw,13px)]">
              Technologies we use
              <span className="h-px w-[28px] bg-[#8FA7FF]" />
            </p>
            <h2 className="mt-[14px] text-[30px] font-bold leading-[1.2] tracking-tight text-[#0B1B4D] sm:text-[34px] lg:text-[clamp(26px,2.4vw,40px)]">
              Modern Tech Stack
              <br />
              for <span className="text-[#1E5BFF]">Powerful Websites</span>
            </h2>
            <p className="mt-[12px] max-w-[440px] text-[15px] leading-[1.55] text-slate-600 lg:text-[clamp(13px,1.05vw,17px)]">
              We use the latest technologies and frameworks to build fast, secure and scalable custom websites.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-[14px] self-center sm:grid-cols-4 lg:gap-[clamp(10px,1.1vw,18px)]">
            {tech.map((t) => (
              <div
                key={t.label}
                className="flex aspect-[1/0.92] flex-col items-center justify-center gap-[clamp(8px,0.9vw,14px)] rounded-[16px] bg-white/95 px-[8px] shadow-[0_10px_28px_-18px_rgba(40,60,140,0.3)] transition hover:-translate-y-1"
              >
                <span
                  className={`inline-flex h-[64px] w-[64px] items-center justify-center rounded-full text-[36px] lg:h-[clamp(52px,4.6vw,76px)] lg:w-[clamp(52px,4.6vw,76px)] lg:text-[clamp(28px,2.6vw,44px)] ${t.ring} ${t.cls}`}
                >
                  <t.icon />
                </span>
                <span className="text-center text-[14px] font-semibold text-[#0B1B4D] lg:text-[clamp(12px,1vw,16px)]">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export default TechStack;
